import i18next from "i18next"
import { initReactI18next } from "react-i18next"

import de_translation from "./locales/de.json"
import en_translation from "./locales/en.json"
import es_translation from "./locales/es.json"
import fr_translation from "./locales/fr.json"
import it_translation from "./locales/it.json"

i18next.use(initReactI18next).init({
  lng: "en",
  resources: {
    en: {
      translation: en_translation
    },
    fr: {
      translation: fr_translation
    },
    de: {
      translation: de_translation
    },
    it: {
      translation: it_translation
    },
    es: {
      translation: es_translation
    }
  },
  fallbackLng: "en"
})
